import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import CardBox from '../components/cards/cards';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import OtpComponent from '../components/otp';
import Timer from '../components/timer/index';
import { Button, CircularProgress } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notificationAlertErrorApi } from './../../../method/notificationAlertErrorApi/notificationAlertErrorApi'
import { validateOTP } from './../../../../redux/register/validateOTP/validateOTP'
import { retray_send_otp_api } from './../../../../redux/retryOtp/retryOtp';
import { actionTypes as actionTypesNotif } from './../../../../redux/notificationAlert/index';
import {setCookie} from './../../../method/cookie/cookiePouyanBroker';
import { convertDigitToEnglish } from "../../../method/convertDigitToEnglish";
import { convertPersianToEnglishDigits } from "../../../method/converter/converterText";


let useStyles = makeStyles(() => ({
    root: {
        width: '100%'
    },
    gridTilte: {
        fontSize: 16,
        marginBottom: 10,
        marginTop: 64,
        maxWidth: '100%',
        "@media(max-width : 505px)": {
            fontSize: 14,
            minWidth: '100%',
        },
    },
    desc: {
        fontWeight: 'bold',
    },
    customButton: {
        backgroundColor: '#0B1742 !important',
        color: '#fff',
        margin: 'auto !important',
        minWidth: "100% !important",
        minHeight: "40px !important",
    },
    title: {
        fontSize: 18,
        color: '#757590',
        marginBottom: 16,
    },

}))


const Index = () => {

    let classes = useStyles();
    const location = useLocation();
    const formikRef = useRef();
    let dispatch = useDispatch();
    const navigate = useHistory();

    const { message, national_id, servics, data } = location.state || {};



    const [InputSmsCode, setInputSmsCode] = useState({
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
        6: "",
    });


    const initialValues = {
        otp: '',
    };


    const validationSchema = Yup.object().shape({
        otp: Yup.string()
            .matches(/^\d{5}$/, ' کد تایید باید 5 رقم باشد')
            .transform(convertPersianToEnglishDigits)
            .required('کد تایید الزامی است'),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        apiSubmitGetProfileOtpSejam(values, setSubmitting, resetForm)
    };


    const apiSubmitGetProfileOtpSejam = (values, setSubmitting, resetForm) => {

        setSubmitting(true)

        let payload = {
            data: {
                NationalCode: convertDigitToEnglish(national_id),
                Otp: convertDigitToEnglish(values?.otp)
            },
        }

        validateOTP(payload)
            .then((res) => {
                let token = res?.data?.data?.token
                if(token){
                    setCookie('token', token);
                    setCookie('national_id', national_id);
                }

                if (res?.data?.data && servics === 'sejam') {
                    navigate.push('/register/contarct', { state: { ...location.state, token: token } });
                }
                if ((res?.data?.data && servics === 'changeOms') && data?.requiredRegistration) {
                    navigate.push('/register/contarct', { state: { ...location.state, token: token } });
                }
                if ((res?.data?.data && servics === 'changeOms') && !data?.requiredRegistration) {
                    navigate.push('/register/changeOms', { state: { ...location.state, token: token } });
                }
            })
            .catch((error) => {
                notificationAlertErrorApi(error, dispatch)
                resetForm()
                setInputSmsCode({
                    1: "",
                    2: "",
                    3: "",
                    4: "",
                    5: "",
                    6: "",
                })
            })
            .finally(() => {
                setSubmitting(false)
            })
    }


    const handelBack = () => {
        redirectNatinalId()
    }

    useEffect(() => {
        if (!national_id) {
            redirectNatinalId()
            return
        }
    }, [])

    const redirectNatinalId = () => {
        navigate.push('/register/national', {
            ...location.state
        });
    }

    const RetrySendOtp = () => {

        let payload = {
            data: {
                NationalCode: convertDigitToEnglish(national_id),
            },
            headers: {
                token: data?.token
            }
        }

        retray_send_otp_api(payload)
            .then((res) => {
                if (res?.status == 200) {
                    dispatch(({ type: actionTypesNotif.success, textAlert: 'ارسال پیامک با موفقیت انجام شد' }))
                }
            })
            .catch((error) => {
                notificationAlertErrorApi(error, dispatch)
            })
            .finally(() => { })
    }


    return (
        <CardBox>
            <div className={classes['root']}>
                <div className={classes['gridTilte']}>
                    <h3 className={classes['title']}>
                        وارد کردن کد
                    </h3>
                    <p className={classes['desc']}>
                        {
                            message
                                ? message
                                : servics === 'sejam'
                                    ? 'کد تایید به شماره موبایل ثبت شده در سجام را وارد کنید'
                                    : 'کد تأیید ارسال‌شده به شماره موبایل خود را وارد کنید'

                        }
                    </p>
                </div>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    className={classes['root']}
                    innerRef={formikRef}
                >
                    {({ isSubmitting, errors, touched, setFieldValue }) => {
                        return (
                            <Form autoComplete="off">
                                <div className={classes['gridTextField']}>
                                    <OtpComponent
                                        InputSmsCode={InputSmsCode}
                                        setInputSmsCode={setInputSmsCode}
                                        numberOtp={5}
                                        submiting={() => formikRef.current?.submitForm()}
                                        formikCustom={{
                                            key: 'otp',
                                            setFieldValue: setFieldValue,
                                            errors: errors,
                                            touched: touched,
                                        }}
                                    />
                                </div>
                                <div >
                                    <Timer
                                        initialMinute={2}
                                        initialSeconds={0}
                                        // handleClickAgain={() => handelBack()}
                                        handleClickAgain={() => RetrySendOtp()}
                                    />
                                </div>
                                <div className={classes['gridBtns']}>
                                    <Button
                                        className={classes.customButton}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                        style={{ color: 'white' }}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                در حال ارسال
                                                <CircularProgress size={24} className={classes.progress} />
                                            </>
                                        ) : (
                                            'ثبت کد تایید'
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </CardBox>
    )
}

export default Index                          